import { useMemo } from "react";

import {
  MegaMenuItemData,
  MegaMenuPanelData,
} from "@/common/contracts/mega-menu.contracts";
import { MegaMenuLinkItem } from "@/components/mega-menu/MegaMenuLinkItem";
import { useMegaMenuState } from "@/components/mega-menu/MegaMenuProvider";
import { MegaMenuSeeAllItem } from "@/components/mega-menu/MegaMenuSeeAllItem";
import { Heading } from "@/ui/cva/Heading";

const MAX_ITEMS_PER_COLUMN = 5;

type MegaMenuPanelLinksColumnsProps = {
  title: string;
  data: MegaMenuPanelData;
};

export const MegaMenuPanelLinksColumns = ({
  title,
  data,
}: MegaMenuPanelLinksColumnsProps) => {
  const { hideMenu } = useMegaMenuState();

  const all = useMemo(() => {
    return data.items?.find(item => item.type === "all");
  }, [data.items]);

  const columns = useMemo(() => {
    const links = (data.items ?? []).filter(
      item => item.type !== "all" && !!item.href
    );

    const chunks: MegaMenuItemData[][] = [];
    for (let i = 0; i < links.length; i += MAX_ITEMS_PER_COLUMN) {
      chunks.push(links.slice(i, i + MAX_ITEMS_PER_COLUMN));
    }
    return chunks;
  }, [data.items]);

  return (
    <div className="flex flex-1 flex-col items-start space-y-10">
      <div className="flex items-baseline space-x-2">
        <Heading as="span" size="h3">
          {title}
        </Heading>
        <MegaMenuSeeAllItem item={all} />
      </div>
      <div className="flex space-x-12">
        {columns.map((column, idx) => (
          <ul
            key={idx}
            className="flex flex-col items-start space-y-4"
          >
            {column.map(item => {
              const rawHref = item.href!;
              const href = rawHref.startsWith("/http")
                ? rawHref.substring(1)
                : rawHref;

              return (
                <MegaMenuLinkItem
                  key={item.id}
                  href={href}
                  label={item.label}
                  external={href.startsWith("http")}
                  onSelect={hideMenu}
                />
              );
            })}
          </ul>
        ))}
      </div>
    </div>
  );
};
